// ─────────────────────────────────────────────────────────────────
// Custom tenant modules — bespoke React components, one folder each.
//
// The code here ships in everyone's bundle but is DORMANT unless a
// tenant's registry manifest names it (component: "custom:<key>").
// Activation, placement, config, and menu entries are registry edits
// (admin.plunk.io); writing a NEW custom module is a normal PR.
//
// Contract: each component receives
//   config — the manifest entry's config object (API bases, options…)
//   range  — the hosting page's range token (widget placement only)
// and owns its own data fetching entirely (external APIs included —
// if the API lacks CORS, proxy it; see the upload Lambda's proxy
// pattern).
//
// SECURITY: never load component code FROM the registry or a URL —
// the registry controls wiring only, code goes through git + deploy.
// ─────────────────────────────────────────────────────────────────
import ExamplePanel from "./example-panel";
import InsightsSearchTerms from "./insights-search-terms";
const CUSTOM_MODULES = {
  "example-panel": ExamplePanel,
  "insights-search-terms": InsightsSearchTerms
};
export default CUSTOM_MODULES;